/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional ETag from the last read of the module submission document.
 */
export type ModuleGradeOverrideRequestLastKnownEtag = string | null;
